import Paper from "@mui/material/Paper";
import React from "react";
import { connect } from "react-redux";
import { ClaimStructureAllotmentJson } from "../../../DynamicFormsJson/MastersJSON/claimStructureAllotmentJson";

import {
  checkedListEmptyMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
} from "../../../config/messageconstant";

import { Grid } from "@mui/material";
import { compose } from "recompose";
import {
  getAreaByTalukaPostBodyUpdated,
  getAreaByUserType,
} from "../../../Slice/area.slice";
import { getActiveClaimStructure } from "../../../Slice/claim.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getRegionNew } from "../../../Slice/region.slice";
import {
  getSalesExecutive,
  getSalesPersonByAreaAndStockHolderTypeForClaimStructure,
  getSalesTeamWithAreaNames,
  getSalesTeamWithAreaNamesForClaim,
  setSalesTeamWithAreaNames,
  setSalesPersonByAreaAndStockHolderTypeForClaimStructure,
  getSalesTeamByTypeForClaimStructureAssignation,
} from "../../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../../Slice/state.slice";
import {
  getStockStakeHolderType,
  getStockStakeHolderTypeForList,
} from "../../../Slice/stockStakeHolderType.slice";
import { getTalukaByDistrict } from "../../../Slice/taluka.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import { ButtonCompo } from "../../../components/Comman/Button";
import CheckBoxSelectionTable from "../../../components/Comman/RT/CheckBoxSelectionTable";
import DynamicFormWithoutValidation from "../../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../../components/withRouter";
import {
  mandatoryCheck,
  ValidationCheck,
} from "../../../config/ValidationCheck";
import endpoint from "../../../config/endpoints";
import { apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

let columnsForSalesTeam = [
  {
    title: "Sr.No.",
    name: "index",
    positionCenter: true,
    showInscreen: true,
    canSearch: true,
    alignCenter: "center",
    align: "center",
  },
  {
    title: "Employee Code",
    name: "employeeCode",
    positionCenter: true,
    showInscreen: true,
    canSearch: true,
    alignCenter: "center",
    align: "center",
  },
  {
    title: "Name",
    name: "name",
    positionCenter: true,
    showInscreen: true,
    canSearch: true,
    alignCenter: "left",
  },
  {
    title: "Type",
    name: "stockStakeHolderTypeName",
    positionCenter: true,
    showInscreen: true,
    canSearch: true,
    alignCenter: "left",
  },
  {
    title: "Reporting Manager",
    name: "reportingManagerName",
    positionCenter: true,
    showInscreen: true,
    canSearch: true,
    alignCenter: "left",
  },
  {
    title: "Reporting Manager Type",
    name: "reportingManagerTypeName",
    positionCenter: true,
    showInscreen: true,
    canSearch: true,
    alignCenter: "left",
  },

  // comment By Ritesh
  // {
  //   title: "Area",
  //   name: "areaNames",
  //   positionCenter: true,
  //   showInscreen: true,
  //   canSearch: true,
  //   alignCenter: "left",
  // },
];

class ClaimStructureAllotmentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        stockHolderTypeDetail:
          this.props.stockStakeHolderType?.stockStakeHolderTypeList,
        salesPersonDetail: this.props.salesTeamList?.salesExecutive,
        typeDetail: [],
      },
      showCheckRecord: false,
      selection: [],
      claimStructure: "",
      salesTeamId: "",
      fieldData: { type: "0" },
      formErrors: {},
    };
  }

  async componentDidMount() {
    const {
      getActiveClaimStructure,
      setSalesPersonByAreaAndStockHolderTypeForClaimStructure,
      getStockStakeHolderTypeForList,
      showLoador,
      getStockStakeHolderType,
      showNotification,
      getRegionNew,
    } = this.props;
    if (navigator.onLine) {
      setSalesPersonByAreaAndStockHolderTypeForClaimStructure({ row: [] });

      showLoador({ loador: true });
      await getRegionNew().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      await getStockStakeHolderTypeForList().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      await getActiveClaimStructure().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
        ({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        }
      );

      if (this.props.params.id) {
        this.setState({ claimStructure: this.props.params.id });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }

    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }

    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }

    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }

    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }

    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }

    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaUserTypeDetail: nextProps.areaList?.area,
          },
        });
      }
    }

    if (this.props.stockStakeHolderType !== nextProps.stockStakeHolderType) {
      if (
        this.props.stockStakeHolderType?.stockStakeHolderTypeList !==
        nextProps.stockStakeHolderType?.stockStakeHolderTypeList
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderTypeDetail:
              nextProps.stockStakeHolderType?.stockStakeHolderTypeList,
          },
        });
      }
    }

    if (this.props.salesTeamList !== nextProps.salesTeamList) {
      if (
        this.props.salesTeamList?.salesExecutive !==
        nextProps.salesTeamList?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesPersonDetail: nextProps.salesTeamList?.salesExecutive,
          },
        });
      }
    }

    if (this.props.claimStructureList !== nextProps.claimStructureList) {
      if (
        this.props.claimStructureList?.claimStructure !==
        nextProps.claimStructureList?.claimStructure
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            claimStructureDetail: nextProps.claimStructureList?.claimStructure,
          },
        });
      }
    }
  }
  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBodyUpdated,
      getSalesExecutive,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaIdsByPost = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBodyUpdated({
          talukaIds: talukaIdsByPost,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.stockHolderType && data.stockHolderType != "") {
        showLoador({ loador: true });
        await getSalesExecutive({
          stockStakeHolderId: data.stockHolderType,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  checkValidationOnSubmit = () => {
    const { fieldData, adminFlag } = this.state;

    let fieldMeta = [];

    if (this.props.params.id) {
      if (fieldData.type == 0) {
        fieldMeta = ClaimStructureAllotmentJson.fieldMetaForAreaGetById;
      } else if (fieldData.type == 1) {
        fieldMeta = ClaimStructureAllotmentJson.fieldMetaForSalesTeamGetById;
      } else if (fieldData.type == 2) {
        fieldMeta =
          ClaimStructureAllotmentJson.fieldMetaForUnderSalesTeamGetById;
      } else if (fieldData.type == 3) {
        fieldMeta = ClaimStructureAllotmentJson.fieldMetaForTypeWiseGetById;
      } else {
        fieldMeta = [];
      }
    } else {
      if (fieldData.type == 0) {
        fieldMeta = ClaimStructureAllotmentJson.fieldMetaForArea;
      } else if (fieldData.type == 1) {
        fieldMeta = ClaimStructureAllotmentJson.fieldMetaForSalesTeam;
      } else if (fieldData.type == 2) {
        fieldMeta = ClaimStructureAllotmentJson.fieldMetaForUnderSalesTeam;
      } else if (fieldData.type == 3) {
        fieldMeta = ClaimStructureAllotmentJson.fieldMetaForTypeWise;
      } else {
        fieldMeta = [];
      }
    }

    const mandatoryCheckErrors = mandatoryCheck({ fieldData, fieldMeta });
    this.setState({ formErrors: mandatoryCheckErrors.formErrors });

    if (!mandatoryCheckErrors.formValid) return false;

    const validationCheckErrors = ValidationCheck({ fieldData, fieldMeta });
    this.setState({ formErrors: validationCheckErrors.formErrors });

    return validationCheckErrors.formValid;
  };

  onSearchList = () => {
    const { fieldData, adminFlag } = this.state;

    const {
      getSalesPersonByAreaAndStockHolderTypeForClaimStructure,
      getSalesTeamWithAreaNames,
      getSalesTeamWithAreaNamesForClaim,
      getSalesTeamByTypeForClaimStructureAssignation,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      let claimStructure = this.props.params.id
        ? this.props.params.id
        : fieldData.claimStructure;

      let salesTeamId = fieldData.salesTeamIds;

      this.setState({
        claimStructure: claimStructure,
        salesTeamId: salesTeamId,
      });

      let dataJson = {
        stockStakeHolderTypeId: fieldData.stockHolderType,
        areaIds:
          typeof fieldData.area == "string"
            ? fieldData.area.split(",")
            : fieldData.area,
      };

      let dataJsonNew = {
        claimStructureHeaderId: claimStructure,
        salesTeamId: fieldData.salesTeamIds,
        stockStakeHolderTypeIds:
          typeof fieldData.salesTeamTypeId == "string"
            ? fieldData.salesTeamTypeId.split(",")
            : fieldData.salesTeamTypeId,
      };

      let dataJsonForType = {
        claimStructureHeaderId: claimStructure,
        stockStakeHolderTypeIds:
          typeof fieldData.stockHolderType == "string"
            ? fieldData.stockHolderType.split(",")
            : fieldData.stockHolderType,
      };
      if (this.checkValidationOnSubmit()) {
        if (fieldData.type == 0) {
          showLoador({ loador: true });
          getSalesPersonByAreaAndStockHolderTypeForClaimStructure({
            claimStructureHeaderId: claimStructure,
            dataJson: dataJson,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        } else if (fieldData.type == 1) {
          showLoador({ loador: true });
          getSalesTeamWithAreaNames({
            claimStructureHeaderId: claimStructure,
            salesTeamId: salesTeamId,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        } else if (fieldData.type == 2) {
          showLoador({ loador: true });
          getSalesTeamWithAreaNamesForClaim({
            dataJson: dataJsonNew,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        } else {
          showLoador({ loador: true });
          getSalesTeamByTypeForClaimStructureAssignation({
            dataJson: dataJsonForType,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  getSelectedList = (e) => {
    this.setState({
      selection: e,
    });
    const rowList =
      this.props.salesPersonList.salesPersonByAreaAndStockHolderTypeForClaimStructure.map(
        (rowData) => {
          const filterData = e.filter((id) => rowData.id == id);
          return {
            ...rowData,
            checked: filterData.length != 0 ? true : false,
          };
        }
      );
    this.props.setSalesPersonByAreaAndStockHolderTypeForClaimStructure({
      row: rowList,
    });
  };

  onSubmit = () => {
    const { selection, claimStructure } = this.state;
    const { showLoador, showNotification } = this.props;

    if (selection.length === 0) {
      showNotification({ msg: checkedListEmptyMsg, severity: "error" });
    } else {
      this.onSave();
    }
  };

  onSave = () => {
    const { selection, claimStructure } = this.state;
    const { showLoador, showNotification } = this.props;

    let saveJsonData = {
      salesTeamIds: selection,
      claimStructureHeaderId: claimStructure,
    };

    swal({
      title: "Are you sure?",
      text: saveWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        apiPost({
          url: endpoint.claimStructureAllotment + "/save-by-sales-teams",
          postBody: saveJsonData,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            showNotification({ msg: savemsg });
            if (this.props.params.id) {
              this.props.navigate(-1);
            } else {
              window.location.reload();
            }
          } else {
            showNotification({ msg: saveFailedMsg, severity: "error" });
          }
        });
      }
    });
  };

  onDataChange = (fieldName, newValue) => {
    const { fieldData, dynamicMasterData, adminFlag } = this.state;
    const { setSalesTeamWithAreaNames } = this.props;

    const fieldMeta = this.props.params.id
      ? fieldData.type == 0
        ? ClaimStructureAllotmentJson.fieldMetaForAreaGetById
        : fieldData.type == 1
          ? ClaimStructureAllotmentJson.fieldMetaForSalesTeamGetById
          : fieldData.type == 2
            ? ClaimStructureAllotmentJson.fieldMetaForUnderSalesTeamGetById
            : fieldData.type == 3
              ? ClaimStructureAllotmentJson.fieldMetaForTypeWiseGetById
              : []
      : fieldData.type == 0
        ? ClaimStructureAllotmentJson.fieldMetaForArea
        : fieldData.type == 1
          ? ClaimStructureAllotmentJson.fieldMetaForSalesTeam
          : fieldData.type == 2
            ? ClaimStructureAllotmentJson.fieldMetaForUnderSalesTeam
            : fieldData.type == 3
              ? ClaimStructureAllotmentJson.fieldMetaForTypeWise
              : [];

    const dataToSearch = {};
    let dataToReset = { ...this.state.fieldData };

    if (fieldName === "type") {
      dataToReset = { type: newValue };
      this.setState(
        {
          fieldData: dataToReset,
          dynamicMasterData: {
            ...dynamicMasterData,

            regionDetail: [],
            stateDetail: [],
            zoneDetail: [],
            districtDetail: [],
            talukaDetail: [],
            areaDetail: [],
            salesExecutiveDetail: [],
            typeDetail: [],
          },
        },
        () => {
          if (newValue == 0) {
            this.props.getRegionNew();
          } else if (newValue == 0 || newValue == 1 || newValue == 2) {
            this.props.getStockStakeHolderType({ userTypeIds: "3,4" });
          }
          this.props.setSalesTeamWithAreaNames({
            row: [],
          });
        }
      );
      return;
    }

    (fieldMeta || []).map((currentField) => {
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");

        masterKeyList.forEach((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
        });

        this.getListById(dataToSearch);
      }

      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.forEach((key) => {
          if (key == fieldName && dataToReset[currentField.dataKey]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }

      return null;
    });

    if (fieldName === "stockHolderType") {
      const allTypes = dynamicMasterData.stockHolderTypeDetail || [];
      const selectedType = allTypes.find((item) => item.id === newValue);

      let filteredTypes = [];
      if (selectedType) {
        if (selectedType.userType.id === 3) {
          filteredTypes = allTypes.filter(
            (item) =>
              item.userType.id === 3 && item.sortOrder > selectedType.sortOrder
          );
          const dsr = allTypes.find((item) => item.userType.id === 4);
          if (dsr) filteredTypes.push(dsr);
        } else if (selectedType.userType.id === 4) {
          filteredTypes = [];
        }
      }

      this.setState({
        dynamicMasterData: {
          ...dynamicMasterData,
          typeDetail: filteredTypes,
        },
        fieldData: {
          ...dataToReset,
          salesTeamTypeId: "",
        },
      });
    }

    dataToReset[fieldName] = newValue;
    this.setState({
      fieldData: dataToReset,
    });
  };

  render() {
    const {
      dynamicMasterData,
      selection,

      fieldData,

      type,
      formErrors,
    } = this.state;
    const { salesPersonList } = this.props;

    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutValidation
            dynamicMasterData={dynamicMasterData}
            screenTitle={ClaimStructureAllotmentJson.screenTitle}
            fieldMeta={
              this.props.params.id
                ? fieldData.type == 0
                  ? ClaimStructureAllotmentJson.fieldMetaForAreaGetById
                  : fieldData.type == 1
                    ? ClaimStructureAllotmentJson.fieldMetaForSalesTeamGetById
                    : fieldData.type == 2
                      ? ClaimStructureAllotmentJson.fieldMetaForUnderSalesTeamGetById
                      : fieldData.type == 3
                        ? ClaimStructureAllotmentJson.fieldMetaForTypeWiseGetById
                        : []
                : fieldData.type == 0
                  ? ClaimStructureAllotmentJson.fieldMetaForArea
                  : fieldData.type == 1
                    ? ClaimStructureAllotmentJson.fieldMetaForSalesTeam
                    : fieldData.type == 2
                      ? ClaimStructureAllotmentJson.fieldMetaForUnderSalesTeam
                      : fieldData.type == 3
                        ? ClaimStructureAllotmentJson.fieldMetaForTypeWise
                        : []
            }
            apiBaseURL={ClaimStructureAllotmentJson.apiBaseURL}
            formErrors={formErrors}
            // showSaveBtn={ClaimStructureAllotmentJson.showSaveBtn}
            showSaveBtn={true}
            saveBtnText={"Search"}
            showSaveNextBtn={false}
            showSaveBtnMain={false}
            onFormSave={this.onSearchList}
            // getDataById={this.getDataById}
            getListById={this.getListById}
            getByIdApi={true}
            callApi={true}
            fieldData={fieldData}
            onDataChange={this.onDataChange}
            showBackToList={this.props.params.id ? true : false}
          />

          {salesPersonList.salesPersonByAreaAndStockHolderTypeForClaimStructure
            .length !== 0 && (
              <CheckBoxSelectionTable
                selection={selection}
                onSelectionChange={this.getSelectedList}
                columns={columnsForSalesTeam}
                rows={
                  salesPersonList.salesPersonByAreaAndStockHolderTypeForClaimStructure
                }
                isActionColActive={false}
              />
            )}

          <br />
          {salesPersonList.salesPersonByAreaAndStockHolderTypeForClaimStructure
            .length !== 0 && (
              <>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  md={12}
                  lg={12}
                  container
                  justifyContent="right"
                >
                  <ButtonCompo
                    size="medium"
                    type="button"
                    variant="contained"
                    name="Submit"
                    onClick={this.onSubmit}
                  />
                </Grid>
              </>
            )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  claimStructureList: state.claim,
  stockStakeHolderType: state.stockStakeHolderType,
  salesPersonList: state.salesExecutive,
  stakeHolderTypeList: state.stockStakeHolderType,
  salesTeamList: state.salesExecutive,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getRegionNew,
  getStateByRegion,
  getDistrictByZone,
  getTalukaByDistrict,
  getZoneByState,
  getAreaByTalukaPostBodyUpdated,
  getAreaByUserType,
  getActiveClaimStructure,
  getStockStakeHolderTypeForList,
  getSalesPersonByAreaAndStockHolderTypeForClaimStructure,
  setSalesPersonByAreaAndStockHolderTypeForClaimStructure,
  getSalesExecutive,
  getStockStakeHolderType,
  getSalesTeamWithAreaNamesForClaim,
  getSalesTeamWithAreaNames,
  setSalesTeamWithAreaNames,
  getSalesTeamByTypeForClaimStructureAssignation,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ClaimStructureAllotmentList);
